import { Skeleton } from "@/components/ui/skeleton";

export function RecentActivityRowSkeleton() {
  return (
    <div className="flex items-start gap-4 px-6 py-4">
      <Skeleton className="mt-0.5 size-4 shrink-0" />
      <div className="flex flex-1 flex-col gap-2">
        <Skeleton className="h-3.5 w-2/3" />
        <Skeleton className="h-3 w-24" />
      </div>
      <Skeleton className="h-3 w-12 shrink-0" />
    </div>
  );
}
